/**
 * @module womeninbotany.utility.altchaComponent
 */

/**
 * @type {!angular.Module}
 */
const exports = angular.module('womeninbotanyAltcha', [
]);

/**
 * Provides a directive for altcha-widget
 *
 * @return {angular.Directive} Directive Definition Object.
 * @ngInject
 * @ngdoc directive
 * @ngname womeninbotanyAltchaDirective
 */
exports.directive_ = function () {
  return {
    restrict: 'E',
    require: 'ngModel',
     /**
     * The directive reacts on altcha-widget
     * @param scope
     * @param element
     * @param attr
     * @param ctrl
     */
    link: function (scope, element, attr, ctrl) {
      element.on("statechange", function (event) {
        if (event.detail.state == 'verified') {
          // console.log('state:', event.detail.payload);
          ctrl.$setViewValue(event.detail.payload);
        }
      });
    }
  }
};

exports.directive('altchaWidget', exports.directive_);

export default exports;
